import { render, staticRenderFns } from "./guias-orientacoes.vue?vue&type=template&id=fbaa99b6"
import script from "./guias-orientacoes.vue?vue&type=script&lang=js"
export * from "./guias-orientacoes.vue?vue&type=script&lang=js"
import style0 from "./guias-orientacoes.vue?vue&type=style&index=0&id=fbaa99b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports